import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <span className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-background-50 text-sm"></i>
              </span>
              <span className="text-lg font-bold font-heading tracking-tight whitespace-nowrap">
                Kakobuy<span className="text-accent-300">Finds</span>
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed mt-4 max-w-xs">
              {t('footer_disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">{t('footer_categories')}</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">{t('footer_categories')}</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">{t('nav_guide')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/kakobuy-spreadsheet" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                Kakobuy Spreadsheet – poradnik
              </Link>
              <Link to="/poradnik-zakupowy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                Poradnik zakupowy
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                {t('hero_btn_primary')}
              </a>
            </div>

            <div className="flex gap-4 mt-6">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors cursor-pointer">
                <i className="ri-global-line text-sm text-background-50"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors cursor-pointer">
                <i className="ri-shopping-cart-2-line text-sm text-background-50"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors cursor-pointer">
                <i className="ri-search-line text-sm text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} KakobuyFinds.autos. {t('footer_rights')}
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap">
              Kakobuy Spreadsheet
            </a>
            <Link to="/kakobuy-spreadsheet" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap">
              {t('nav_guide')}
            </Link>
            <Link to="/poradnik-zakupowy" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap">
              Poradnik zakupowy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}